if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      async addMultipleToCart(extraItems) {
        if (!Array.isArray(extraItems) || extraItems.length === 0) return;
          const final_items = Object.values(
            extraItems.reduce((acc, item) => {
              if (!acc[item.id]) {
                acc[item.id] = { id: item.id, quantity: 0 };
              }
              acc[item.id].quantity += item.quantity;
              return acc;
            }, {})
          );
console.log("final_items",final_items);

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: final_items })
          });
      
          const data = await res.json();
          console.log("Added:", data);
        } catch (err) {
          console.error("Failed:", err);
        }
        try {
          
          const updates = {};
        
          final_items.forEach(item => {
            updates[item.id] = item.quantity || 1;
          });
        
          const payload = {
            updates,
            discount: "cs_bundle"   
          };
          console.log("final_items", final_items);
          console.log("payload", payload);
        
          const res = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(payload)
          });
        
          const data = await res.json();
          console.log("Updated cart:", data);
        
        } catch (err) {
          console.error("Update failed:", err);
        }
        
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if( !!__is_bundles ){
          let ret = await ATCBundle();
          if( !ret ) return;
        }
        
        let extraItems = [];
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        
        if (window.__is_bundles) {
          // build your names from the global designs array (adjust if your var name differs)
          // const designs = collectDesigns();
                    const names = designs.length
            ? designs
                .filter(d => !d.extra)
                .map(d => d.name)
                .join(', ')
            : '';

            extraItems = designs.length
            ? designs
                .filter(d => d.extra === true)
                .map(d => ({
                  id: Number(d.id),
                  quantity: Number(d.quantity) || 1
                }))
            : [];

          console.log("extraItems",extraItems);


            
            // const custom = Array.isArray(designs)
            // ? designs
            //     .filter(d => {
            //       console.log(`Design: ${d.name}, Extra: ${d.extra}`);
            //       return !d.extra;
            //     })
            //     .flatMap(d => Array((parseInt(d.quantity) || 0)).fill(d.name))
            //     .join(', ')
            // : '';
            
            
            
                        
          
          // only append if we actually have names
          if (names) {
            formData.append('properties[designs]', names);
          }
          async function prepareExtraItems(formData, extraItems) {

              let cs_var = formData.get('bundle') || '';
              cs_var = cs_var.toString().trim().toLowerCase();

              let extraItemsAddon = [];

              if (cs_var === 'basic') {
                extraItemsAddon = [
                  { id: 43817428058205, quantity: 1 }
                ];
              } else if (cs_var === 'standard') {
                extraItemsAddon = [
                  { id: 43817428058205, quantity: 1 },
                  { id: 43817428353117, quantity: 1 }
                ];
              } else if (cs_var === 'premium') {
                extraItemsAddon = [
                  { id: 43817428058205, quantity: 1 },
                  { id: 43817428353117, quantity: 1 },
                  { id: 43814392332381, quantity: 1 }
                ];
              } else {
                extraItemsAddon = [];
              }

              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              const cartVariantIds = cart.items.map(i => i.id);

              const filteredAddon = extraItemsAddon.filter(
                item => !cartVariantIds.includes(item.id)
              );

              if (filteredAddon.length > 0) {
                extraItems.push(...filteredAddon);
              }

              return extraItems;
            }

        config.body = formData;
      const finalExtraItems = await prepareExtraItems(formData, extraItems);
      console.log("FINAL EXTRA ITEMS TO ADD:", finalExtraItems);
       await this.addMultipleToCart(finalExtraItems);
}
else{
  config.body = formData;
}
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
          initRecommendations();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
